import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Alert
} from '@mui/material';
import i18n from '../../i18n';
import { formatError } from '../../utils/formatError';

export default class AssignSettingDialog extends React.Component {
    onClose = () => {};
    id = '';
    title = i18n.t('assignSettingDialog.title');
    server = null;

    constructor(props) {
        super(props);

        this.id = props.id;
        this.onClose = props.onClose;
        this.server = props.server;
        if (props.title) this.title = props.title;

        this.state = {
            dialogOpen: true,
            settingsJson: '',
            showAuthenticator: false,
            code: '',
            error: '',
            loading: false
        };
    }

    handleClose = () => {
        this.setState({
            dialogOpen: false,
            settingsJson: '',
            showAuthenticator: false,
            code: '',
            error: ''
        });
        this.onClose?.();
    };

    handleSave = async () => {
        const { showAuthenticator, settingsJson, code } = this.state;

        try {
            JSON.parse(settingsJson);
        } catch {
            this.setState({ error: i18n.t('errors.invalidJson') });
            return;
        }

        if (!showAuthenticator) {
            this.setState({ showAuthenticator: true, error: '' });
            return;
        }


        try {
            this.setState({ loading: true, error: '' });
            const payload = {
                id: this.id,
                code,
                settingsJson
            };

            const res = await this.server.assign(payload);
            if (res.error !== 'OK') {
                throw res;
            }
            this.handleClose();


        } catch (e) {
            this.setState({ error: formatError(e) });
        } finally {
            this.setState({ loading: false });
        }
    };

    render() {
        const {
            dialogOpen,
            settingsJson,
            showAuthenticator,
            code,
            error,
            loading
        } = this.state;

        return (
            <Dialog open={dialogOpen} onClose={this.handleClose} fullWidth maxWidth="sm">
                <DialogTitle>{this.title}</DialogTitle>
                <DialogContent>
                    {error && (
                        <Alert severity="error" sx={{ mb: 2 }}>
                            {error}
                        </Alert>
                    )}
                    <TextField
                        label={i18n.t('assignSettingDialog.settingsLabel')}
                        value={settingsJson}
                        onChange={(e) => this.setState({ settingsJson: e.target.value })}
                        fullWidth
                        multiline
                        minRows={5}
                        variant="outlined"
                        margin="normal"
                    />
                    {showAuthenticator && (
                        <>
                            <Alert severity="warning" sx={{ mt: 1 }}>
                                {i18n.t('assignSettingDialog.authPrompt')}
                            </Alert>
                            <TextField
                                label={i18n.t('assignSettingDialog.authCodeLabel')}
                                value={code}
                                onChange={(e) => this.setState({ code: e.target.value })}
                                fullWidth
                                variant="outlined"
                                margin="normal"
                            />
                        </>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose}>
                        {i18n.t('buttons.cancel')}
                    </Button>
                    <Button
                        onClick={this.handleSave}
                        variant="contained"
                        disabled={loading}
                    >
                        {loading
                            ? i18n.t('buttons.saving')
                            : i18n.t('buttons.save')}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}
